import { useCallback, useState } from 'react';
import { PickupPointSelector } from 'components/gruenland/organisms/checkout/shipping/PickupPointSelector';
import {
  ShippingMethodSelector,
  ShippingMethod,
} from 'components/gruenland/organisms/checkout/shipping/ShippingMethodSelector';

export type { ShippingMethod };

export interface PickupPoint {
  id: string;
  name: string;
  address: string;
  courier: string;
  type: string;
  city: string;
  country: string;
  zip: string;
  street: string;
  state: string;
}

interface ShippingSelectionProps {
  onComplete: (method: ShippingMethod, pickupPoint: PickupPoint | null) => void;
}

const ShippingSelection = ({ onComplete }: ShippingSelectionProps) => {
  const [step, setStep] = useState<'method-selection' | 'pickup-selection'>('method-selection');
  const [pickerEverShown, setPickerEverShown] = useState(false);

  const handleMethodSelect = useCallback(
    (method: ShippingMethod) => {
      if (method === 'pickup') {
        setPickerEverShown(true);
        setStep('pickup-selection');
      } else {
        onComplete(method, null);
      }
    },
    [onComplete],
  );

  const handlePickupPointSelect = useCallback(
    (point: PickupPoint) => {
      onComplete('pickup', point);
    },
    [onComplete],
  );

  const handleBack = useCallback(() => {
    setStep('method-selection');
  }, []);

  return (
    <>
      {step !== 'pickup-selection' && <ShippingMethodSelector onSelectMethod={handleMethodSelect} />}
      {pickerEverShown && (
        <div className={step !== 'pickup-selection' ? 'hidden' : ''}>
          <PickupPointSelector onSelectPoint={handlePickupPointSelect} onBack={handleBack} />
        </div>
      )}
    </>
  );
};

export default ShippingSelection;
